import { createContext, createElement, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import { useStore } from 'zustand';
import { createStore } from 'zustand/vanilla';

const initialState = {
    moduleName: null,
    responseData: [],
    filteredData: [],
    searchControls: [],
    addControls: [],
    isListChanged: true,
    filterControlValues: [],
    filterValues: null,
    hoverFilterValues: null,
    filterPayload: null,
    gridData: [],
};


const createAppStore = () => createStore((set) => ({
    ...initialState,

    setModuleName: (name) => set({ moduleName: name }),
    setResponseData: (data) => set({ responseData: data }),
    setFilteredData: (data) => set({ filteredData: data }),
    setSearchControls: (data) => set({ searchControls: data }),
    setAddControls: (data) => set({ addControls: data }),
    setIsListChanged: (data) => set({ isListChanged: data }),
    setFilterControlValues: (data) => set({ filterControlValues: data }),
    setFilterValues: (data) => set({ filterValues: data }),
    setHoverFilterValues: (data) => set({ hoverFilterValues: data }),
    setFilterPayload: (data) => set({ filterPayload: data }),
    setGridData: (data) => set({ gridData: data }),




    destroy: () => set({ ...initialState }),
    initialize: (values = {}) => set({ ...initialState, ...values }),
}));

const defaultAppStore = createAppStore();
const AppStoreContext = createContext(null);
const identity = (state) => state;

// Each mounted main tab gets its own provider and therefore its own store.
// Consumers can continue using useAppStore() without knowing which tab owns them.
export function AppStoreProvider({ children }) {
    const storeRef = useRef(null);

    if (!storeRef.current) {
        storeRef.current = createAppStore();
    }

    return createElement(AppStoreContext.Provider, { value: storeRef.current }, children);
}

AppStoreProvider.propTypes = {
    children: PropTypes.node,
};

export const useAppStoreApi = () => useContext(AppStoreContext) || defaultAppStore;

export const useAppStore = (selector = identity) => {
    const store = useAppStoreApi();
    return useStore(store, selector);
};

// Keep the bound-store imperative API available for legacy code outside a provider.
useAppStore.getState = defaultAppStore.getState;
useAppStore.setState = defaultAppStore.setState;
useAppStore.subscribe = defaultAppStore.subscribe;
